export enum LoadingState {
  NotLoaded = 'NotLoaded',
  Loading = 'Loading',
  Loaded = 'Loaded',
  LoadingNextPage = 'LoadingNextPage',
  Failed = 'Failed',
}
